import ShoppingBag from '../src/ShoppingBag/index.tsx';
export default ShoppingBag;
